import React, { useEffect, useState } from 'react'
import { Miniapptopbar, Dashboard } from './components'
import { USER_READUSERHOME } from '../../../config/api'
import { Retrieve_personal_info } from '../../../config/commonfunctions'
import { Search } from '../components/Header/components'
import { Loading } from '../../../components'
import axios from 'axios'
import './Homeuser.css'

function Homeuser(props) {
    
    // for background only
    useEffect(() => {
        let previousbgcolor = ""
        let previousBgimage = ""

        document.body.style.backgroundColor = 'var(--bodypink)'
        document.body.style.backgroundImage = 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'
        return () => {
            document.body.style.backgroundColor = previousbgcolor || '';
            document.body.style.backgroundImage = previousBgimage || '';
        };
    }, [])

    const [loading, setLoading] = useState(true)
    const [data, setData] = useState({})
    const [usertype, setUsertype] = useState('')
    const [abbrev_userlocation, setAbbrev_userlocation] = useState('')


    useEffect(() => {
        try {
            const { token } = Retrieve_personal_info()
            axios({
                method: 'POST',
                url: USER_READUSERHOME,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            })
                .then((result) => {
                    const { data, status } = result
                    const { error } = data
                    if (status === 200 && error === false) {
                        setData(JSON.parse(JSON.stringify(data)))
                        setUsertype(data.usertype)
                        setLoading(false)
                        setAbbrev_userlocation(data.abbrev_userlocation)
                    }
                })
                .catch(e => {
                    console.log('e', e)
                })
        }
        catch (e) {
            console.log(e)
        }
    }, [])

    return !loading
        ? <div className="homeuser_root">
            <Miniapptopbar {...props} usertype={usertype} currentpage={'HOME'} abbrev_userlocation={abbrev_userlocation}/>
            <Search
                {...props}
                wrapperstyle={{ width: '100%', padding: '24px 10px', }}
            // wrapperstyle={{backgroundColor: '#fff1f4',width:'100%', padding:'24px 10px', backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'}}
            />
            <Dashboard data={data} />
        </div>
        : <Loading />
}

export default Homeuser